import { Content } from "@prismicio/client";
import {
  PrismicImage,
  PrismicRichText,
  SliceComponentProps,
} from "@prismicio/react";
import { Text } from "@components/ui";
import style from "./SuiviDietetique.module.scss";

export type SuiviDietetiqueProps =
  SliceComponentProps<Content.SuiviDietetiqueSlice>;

const SuiviDietetique = ({ slice }: SuiviDietetiqueProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={style.root}
    >
      <div className="lk-wrap large">
        <div className="lk-wrap-content">
          <div className={style.row}>
            <div className={style.features}>
              <ul>
                {slice.items.map((item) => (
                  <li>
                    <span>
                      <PrismicImage field={item.icon} alt="" />
                    </span>
                    <Text html={item.label ?? ""}></Text>
                  </li>
                ))}
              </ul>
            </div>
            <div className={style.content}>
              <div className={style.thumbnail}>
                <PrismicImage field={slice.primary.feature} />
              </div>
              <div className={style.text}>
                <Text className={style.title}>
                  <PrismicRichText field={slice.primary.title} />
                </Text>
                <Text className={style.quote}>
                  <PrismicRichText field={slice.primary.description} />
                </Text>
                <Text className={style.name}>
                  <PrismicRichText field={slice.primary.dietitian} />
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuiviDietetique;
